import { Component, OnInit } from '@angular/core';
import {NotificationHistoryService} from "../../../../../components/notification/services/notification-history.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Router} from "@angular/router";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  public openNotification: boolean = false;
  public countedNotifications!: any[];

  constructor(private notificationHistoryService: NotificationHistoryService,
              public route: Router
              ) { }

  ngOnInit() {
    this.getCountedNotificationList();
  }

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  getCountedNotificationList(): any
  {
    this.notificationHistoryService.getCountedNotification().subscribe({
      next: (res: any) => {
        console.log(res);
        this.countedNotifications = res['hydra:member']

        console.log(this.countedNotifications);
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        console.log('Error while fetching the records');
      }
    });
  }

  readNotification(){
    const data = {
      status: true
    }
    this.notificationHistoryService.read(data).subscribe({
      next: (val: any) => {
        console.log(val)
        this.route.navigate(['/notification/history']);
        this.getCountedNotificationList()
      },

      error: (err: any) => {
        console.log(err)
      }
    });
  }

}
